import { CIRCUIT_SIM_RANK } from "../../../../../external-constants";

const actionTypeIdentifier = '0F370BD9-4D21-425C-B515-377C213AD8CE';

export const getCircuitSimList = `GET-CIRCUIT-SIM-LIST-${actionTypeIdentifier}`;
export const deleteCircuitSimItem = `DELETE-CIRCUIT-SIM-ITEM-${actionTypeIdentifier}`;
export const addCircuitSimItem = `ADD-CIRCUIT-SIM-ITEM-${actionTypeIdentifier}`;
export const updateCircuitSimItem = `UPDATE-CIRCUIT-SIM-ITEM-${actionTypeIdentifier}`;
export const resetCircuitSIMDetails = `RESET-CIRCUIT-SIM-DETAILS-${actionTypeIdentifier}`;
export const getCircuitOrderSimList = `GET-CIRCUIT-ORDER-SIM-LIST-${actionTypeIdentifier}`;

export const circuitSimFormModel = {
    ID: -1,
    TypeID: null,
    Type: null,
    Rank: null,
    SerialNumber: null,
    PINNumber: null,
    ProductName: null,
    SIM: null,
    PUK1: null,
    PUK2: null,
    AdditionalInformation: null
}